export const appSettings = {
    siteName: 'Ceylon Bike Rent',
    siteUrl: process.env.NEXT_PUBLIC_URL || 'https://www.ceylonbikerent.com',
    contactPhoneCountry: '94',
    contactPhoneNumber: '719235099',
    contactPhoneFormatted: '+94 71 923 5099',
    contactPhoneFull: '94719235099',
    contactEmail: 'contact@ceylonbikerent.com',
    emails: {
        default: {
            user: 'booking@ceylonbikerent.com',
            admin: ['admin@ceylonbikerent.com', 'johatiran@gmail.com'],
        },
        contact: {
            user: 'contact@ceylonbikerent.com',
            admin: ['admin@ceylonbikerent.com', 'johatiran@gmail.com'],
        },
    },
    sendEmailsEnabled: process.env.ENV !== 'sbox',
};
